export const environment = {
  apiUrl: 'https://sidequest.qapi.hu',
  production: true,
  langStorageKey: 'lang',
  cookieStorageKey: 'cookie',
  recaptchaSiteKey: '6LdVQ74iAAAAAPM-VHTIosmp6n59AVnaD5bHH58e',
  analyticsKey: 'G-T9KK6R7J49',
  sqAnalyticsKey: 'G-9XCDXMJ5M9'
};
